import React from 'react';
import '../../../static/styles/apiguide.scss';
import '../../../static/styles/dashboard.scss';

export default class UpdateLodgingProductRoom extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const col_number_8 = 8;
        const total_levels = 6;
        const level1 = 5;
        const level2 = 4;
        const level2_prefix = level1 - level2;
        const level3 = 3;
        const level3_prefix = level1 - level3;
        const level4 = 2;
        const level4_prefix = level1 - level4;
        const level5 = 1;
        const level5_prefix = level1 - level5;
        return (
            <div>
                <h3 className={"mb0 mt40"}>룸 업데이트</h3>

                <div className="blog-post-meta">
                    <span className="s-post">숙박 상품의 룸 업데이트.</span>
                    <h3 className="request-method">
                        <span className="label label-success">PUT</span>
                    </h3>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <td>Path</td>
                            <td>Example Endpoint</td>
                        </tr>
                        <tr>
                            <td>/v1/marketplace/travel/lodgings/{'{travelProductId}'}/rooms/{'{travelItemId}'}</td>
                            <td>
                                https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/lodgings/1234567890/rooms/11111111
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt10">
                    <h4>Request Parameters</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th colSpan={col_number_8} className="bold">Request Header</th>
                        </tr>
                        <tr>
                            <th colSpan={level1}>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td colSpan={level1}>Request-Vendor-Id</td>
                            <td>O</td>
                            <td>String</td>
                            <td>벤더 아이디 요청</td>
                        </tr>
                        <tr>
                            <th colSpan={col_number_8} className="bold">Path Segment Parameter</th>
                        </tr>
                        <tr>
                            <th colSpan={level1}>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td colSpan={level1}>travelProductId</td>
                            <td>O</td>
                            <td>Long</td>
                            <td>여행상품 id</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>travelItemId</td>
                            <td>O</td>
                            <td>Long</td>
                            <td>여행상품 id</td>
                        </tr>
                        <tr>
                            <th colSpan={col_number_8} className="bold">Body Parameter</th>
                        </tr>
                        <tr>
                            <th colSpan={level1}>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr><td colSpan={level1}>rooms</td><td>X</td><td>List{'<LodgingRoomCreateDto>'}</td><td>객실 생성</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>sellerRoomId</td><td>O</td><td>String</td><td>판매자 자사사이트의 객실ID</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>name</td><td>O</td><td>String</td><td>객실명</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>bedType</td><td>X</td><td>String</td><td>베드타입,자세한 내용을 엑셀 파일을 참고해 주십시오.</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>viewType</td><td>X</td><td>String</td><td>객실전망,자세한 내용을 엑셀 파일을 참고해 주십시오.</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>additionalInfo</td><td>X</td><td>String</td><td>객실 추가 정보</td></tr>
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>saleStartedAt</td><td>X</td><td>String</td><td>Sale started time, format: yyyy-MM-dd HH:mm:ss</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>saleEndedAt</td><td>X</td><td>String</td><td>sale End at, default value:"2099-12-31 23:59:59",format: yyyy-MM-dd HH:mm:ss</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>totalCount</td><td>X</td><td>int</td><td>total count</td></tr>*/}
                        <tr><td>&nbsp;</td><td colSpan={level2}>area</td><td>X</td><td>Double</td><td>지역</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>components</td><td>X</td><td>List</td><td></td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>componentType</td><td>X</td><td>String</td><td>자세한 내용을 엑셀 파일을 참고해 주십시오.</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>count</td><td>X</td><td>Integer</td><td>개수</td></tr>

                        <tr><td>&nbsp;</td><td colSpan={level2}>beds</td><td>X</td><td>List</td><td></td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>bedType</td><td>X</td><td>String</td><td>자세한 내용을 엑셀 파일을 참고해 주십시오.</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>count</td><td>X</td><td>Integer</td><td>개수</td></tr>

                        <tr><td>&nbsp;</td><td colSpan={level2}>images</td><td>O</td><td>List</td><td>이미지</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>sellerUrl</td><td>O</td><td>String</td><td>셀러 이미지 URL</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>sellerUrlMethod</td><td>X</td><td>String</td><td>Http method(GET/POST), default GET</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>representative</td><td>X</td><td>boolean</td><td>이미지가 상품 대표함, 상품당 단일 대표이미지 보유. Default: FALSE</td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>sellerImageCategory</td><td>X</td><td>String</td><td>Description</td></tr>*/}
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>imageGroup</td><td>X</td><td>String</td>
                            <td>이미지 설명. Default Value:BASIC
                                <table className="table table-striped">
                                    <tbody>
                                    <tr><th>Optional Value</th><th>Description</th></tr>
                                    <tr><td>VIEW</td><td>내외관/전경</td></tr>
                                    <tr><td>FACILITY</td><td>부대시설</td></tr>
                                    <tr><td>RESTAURANT</td><td>식당</td></tr>
                                    <tr><td>ETC</td><td>기타</td></tr>
                                    <tr><td>ROOM</td><td>객실</td></tr>
                                    <tr><td>BASIC</td><td>기본</td></tr>
                                    </tbody>
                                </table>
                            </td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>description</td><td>X</td><td>String</td><td>이미지 설명</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>seq</td><td>X</td><td>int</td><td>이미지 순서</td></tr>

                        <tr><td>&nbsp;</td><td colSpan={level2}>amenities</td><td>X</td><td>List</td><td>객실 구비 품목</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>occupancy</td><td>O</td><td>Object</td><td>투숙인원</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>standardOccupancy</td><td>O</td><td>Integer</td><td>기준인원</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>maximumOccupancy</td><td>O</td><td>Integer</td><td>최대인원</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>maximumChildrenOccupancy</td><td>X</td><td>Integer</td><td>어린이 무료 동반 입실</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>freeChildrenAllowed</td><td>X</td><td>boolean</td><td>어린이 무료 동반 입실 가능 여부 (기본값 : False)</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>freeChildrenAge</td><td>X</td><td>Integer</td><td>입실 가능한 어린이 나이</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>freeChildrenOccupancy</td><td>X</td><td>Integer</td><td>입실 가능한 어린이 인원</td></tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h3 className="panel-title"></h3>
                            <a data-toggle="collapse" href = "#createTourDto">Request Body</a>
                        </div>
                        <div id = "createTourDto" className = "panel-collapse collapse">
                            <div id = "createTourDto" className="panel-body">
                    <pre className="ty01">
                        {`
{
  "additionalInfo": "add room - room additional information",
  "amenities": [
    "ROOM_AMENITY_GENERAL_14",
    "ROOM_AMENITY_BATH_85",
    "ROOM_AMENITY_SERVICE_24"
  ],
  "area": 30,
  "bedType": "ROOM_BED_TYPE_101",
  "beds": [
    {
      "count": 1,
      "bedType": "BED_TYPE_89"
    }
  ],
  "components": [
    {
      "count": 1,
      "componentType": "ROOM_COMPONENT_COUNT_109"
    }
  ],
  "images": [
    {
      "description": null,
      "imageGroup": "ROOM",
      "representative": true,
      "sellerImageCategory": null,
      "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/6ad13a4d_z.jpg",
      "sellerUrlMethod": "GET",
      "seq": 0
    },
    {
      "description": null,
      "imageGroup": "ROOM",
      "representative": false,
      "sellerImageCategory": null,
      "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/d9b82d75_z.jpg",
      "sellerUrlMethod": "GET",
      "seq": 0
    },
    {
      "description": null,
      "imageGroup": "VIEW",
      
      "sellerImageCategory": null,
      "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/bffc831a_z.jpg",
      "sellerUrlMethod": "GET",
      "seq": 0
    }
  ],
  "name": "패밀리 타운홈_update",
  "occupancy": {
    "freeChildrenAge": 9,
    "freeChildrenAllowed": false,
    "freeChildrenOccupancy": 0,
    "maximumChildrenOccupancy": 2,
    "maximumOccupancy": 4,
    "standardOccupancy": 2
  },
  "saleEndedAt": "2098-12-31 23:59:59",
  "saleStartedAt": "2020-02-01 00:00:01",
  "sellerRoomId": "seller room 2 - update room",
  "totalCount": 10,
  "viewType": "ROOM_VIEW_113"
}
                        `}
                    </pre>
                            </div>
                        </div>
                    </div>
                </div>

                {/*<div className="table-responsive mt40">*/}
                {/*    <h4>Response Specifications</h4>*/}
                {/*    <table className="table table-striped">*/}
                {/*        <tbody>*/}
                {/*        <tr>*/}
                {/*            <th>Name</th>*/}
                {/*            <th>Type</th>*/}
                {/*            <th>Description</th>*/}
                {/*        </tr>*/}
                {/*        <tr>*/}
                {/*            <td>code</td>*/}
                {/*            <td>String</td>*/}
                {/*            <td>응답 코드</td>*/}
                {/*        </tr>*/}
                {/*        <tr>*/}
                {/*            <td>message</td>*/}
                {/*            <td>String</td>*/}
                {/*            <td>응답 메세지</td>*/}
                {/*        </tr>*/}
                {/*        <tr>*/}
                {/*            <td>data</td>*/}
                {/*            <td>Long</td>*/}
                {/*            <td>여행상품ID</td>*/}
                {/*        </tr>*/}
                {/*        </tbody>*/}
                {/*    </table>*/}
                {/*</div>*/}
                <div className="table-responsive mt40">
                    <h4>Response Specifications</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th colSpan={level1}>Name</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td colSpan={level1}>code</td>
                            <td>String</td>
                            <td>응답 코드</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>message</td>
                            <td>String</td>
                            <td>응답 메세지</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>data</td>
                            <td>Long</td>
                            <td>travel Item Id</td>
                        </tr>

                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h3 className="panel-title">응답값 예시</h3>
                        </div>
                        <div className="panel-body">
                    <pre className="ty01">
                        {`
{
    "code": 200,
    "message": "Room update request successfully received",
    "data": 576983927370022915
}
                        `}
                    </pre>
                        </div>
                    </div>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th>HTTP CODE</th>
                            <th>message</th>
                            <th>설명</th>
                        </tr>
                        <tr>
                            <td>400</td>
                            <td>Bad request</td>
                            <td>요청 파라미터 값이 정확하지 않을 경우에 발생합니다
                                <div>
                                    <a data-toggle="collapse" href="#errorMessagesforCreateProduct">400 Error Messages</a>
                                </div>
                                <div id="errorMessagesforCreateProduct" className="panel-collapse collapse">
                                    <div className="panel-body">
                                        {/*<li>이넘 타입 {'${enumClazz.getSimpleName()}'}에 대한 무효 문자열 값</li>*/}
                                        {/*<li>무효 display category code  </li>*/}
                                        {/*<li>images가 비어있을 수 없음</li>*/}
                                        {/*<li>대표 이미지 단 한장만 허용 가능</li>*/}
                                        {/*<li>국내 여행에 대한 locations가 비어있으면 안됨 </li>*/}
                                        {/*<li>landNumberAddress중 하나와 roadNameAddress를 제공해야함</li>*/}
                                        {/*<li>무효 seqs  </li>*/}
                                        {/*<li>format이 IMAGE가 아닌 경우 content를 반드시 제공해야함</li>*/}
                                        {/*<li>format이 IMAGE인 경우 sellerUrl를 반드시 제공해야함</li>*/}
                                        {/*<li>travelType 및 productDetailType가 일치하지 않음</li>*/}
                                        {/*<li>instantBooking이 false인 경우 estimatedBookingDuration이 0보다 크고 72보다 작거나 같아야됨</li>*/}
                                        {/*<li>연락처에 대표 전화 번호가 하나 있어야함 </li>*/}
                                        {/*<li>무효 travel ticket feature id </li>*/}
                                        {/*<li>무효 travel ticket item feature id </li>*/}
                                        {/*<li>무효 travel ticket feature value </li>*/}
                                        {/*<li>무효 travel ticket item feature value </li>*/}
                                        {/*<li>무효 일자/시간 포맷, 포맷이 {'{pattern}'}이어야함</li>*/}
                                        {/*<li>판매 시작일은 판매 종료일보다 늦지 않아야함</li>*/}
                                        {/*<li>상품 inventoryType이 PERIOD인 경우 usePeriod가 NULL이면 안됨</li>*/}
                                        {/*<li>inventoryType이 DAILY인 경우 usePeriod가 불필요함</li>*/}
                                        {/*<li>publication은 null이 아니어야함</li>*/}
                                        {/*<li>inventoryType을 제공해야함</li>*/}
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>401</td>
                            <td>Unauthorized Error</td>
                            <td>잘못된 인증 정보</td>
                        </tr>
                        <tr>
                            <td>403</td>
                            <td>Forbidden Error</td>
                            <td>클라이언트 에서 인증을 제공하였으나 접속 허가를 받지 못했을 경우에 발생합니다.</td>
                        </tr>
                        <tr>
                            <td>410</td>
                            <td>The resource has been permanently deleted</td>
                            <td>리소스가 삭제되었을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>412</td>
                            <td>Precondition failed</td>
                            <td>전제조건이 충족하지 않아 요청이 처리되지 않을 경우에 발생합니다</td>
                        </tr>
                        <tr>
                            <td>429</td>
                            <td>Too many requests</td>
                            <td>요청이 많을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>504</td>
                            <td>API Gateway response timeout</td>
                            <td>API 게이트웨이 응답시간 초과할 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>521</td>
                            <td>API provider server has error</td>
                            <td>API 프로바이더 서버에 에러가 있을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>524</td>
                            <td>API provider to API gateway connection response timeout</td>
                            <td>API 프로바이더에서 API 게이트웨이 연결 응답 시간 초과할 경우 발생합니다</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/apis/LodgingAPIContent/LodgingProductAPI/UpdateLodingProductRoom.jsx